import Vue from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/routes";

Vue.use(axios);

axios.defaults.withCredentials = true;
axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "Content-type": "application/json",
};

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (401 === error.response.status) {
      store.dispatch("logout_vuex").then(() => {
        router.push("/");
      });
      return Promise.reject(error);
    } else {
      store.dispatch("alerts/error", error.response?.data?.message || "Erro desconhecido");
      return Promise.reject(error);
    }
  }
);
